/**
 * Checks for "click" events on ".js-click-active" selector and adds "active"
 * css class.
 */
(function($){
    var selector = '.js-click-active';
    if (!$(selector).length) return;
    $(document).on('click', selector, function(e){
        // disregard if an inner link is clicked
        if ($(e.target).closest('a').length) return;
        if ($(this).hasClass('active')) $(this).removeClass('active');
        else $(this).addClass('active');
    });
})(jQuery);
